import { InitialStageState } from "@utils/validation";
import { state as STATE } from "../../../../../../interfaces/interfaces";

export const ACTIVE_STEPS = {
    APPOINTMENT_DATE: 0,
    CARE_PLAN_DETAILS: 1,
    ADDRESS_DETAILS: 2,
}

export const ACTIONS = {
    SET_CHARGE_RATE_STATE: (prefix: string) => ({ id: 0, type: "SET_CHARGE_RATE_STATE", prefix }),
    SET_CARE_PLAN_DETAILS: (prefix: string, payload: boolean) => ({ id: 1, type: "SET_CARE_PLAN_DETAILS", prefix, payload }),
    SET_BOOKING_STATE: (prefix: string, payload: boolean) => ({ id: 2, type: "SET_BOOKING_STATE", prefix, payload }),
}

export const initialStageState: InitialStageState = {
    0: {
        id: 0,
        title: "ChargeRate",
        complete: false,
        label: 'Confirm Charge Rate',
        description: `Please confirm the charge rate for this job, apply any reductions or promo codes if needed.`,
    },
    1: {
        id: 1,
        title: "CarePlan",
        complete: false,
        label: 'Offer Care Plan',
        description:
            'Offer Care Plan to customer',
    },
    2: {
        id: 2,
        title: "Booking",
        complete: false,
        label: 'Booking',
        description:
            'Finalise booking',
    },
}

export const reducer = (state: InitialStageState, action: { type: string; id: number; prefix: string | string[]; payload?: boolean }) => {
    switch (action.type) {
        case "SET_CHARGE_RATE_STATE":
            const charge_rate_state = state[action.id].complete
            if (!charge_rate_state || STATE.Step3_1Valid)
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        complete: true,
                    },
                };
            if (charge_rate_state || !STATE.Step3_1Valid)
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        complete: false,
                    },
                };
            return state;

        case "SET_CARE_PLAN_DETAILS":
            const care_plan_state = state[action.id].complete
            const isPlanCompleted = action.payload
            // check if action.prefix is array
            // create array to hold boolean values

            if (!care_plan_state && isPlanCompleted) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (care_plan_state && !isPlanCompleted) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            // STATE.Step3_2Valid = isPlanCompleted || false
            return state

        case "SET_BOOKING_STATE":
            const booking_state = state[action.id].complete
            // create variable to hold prefix a string
            const isBookingPaymentCompleted = action.payload
            // check if action.prefix is array
            // create array to hold boolean values

            if (!booking_state && isBookingPaymentCompleted) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (booking_state && !isBookingPaymentCompleted) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            // STATE.Step3_3Valid = action.payload || false
            return state

        default:
            return state;
    }
};
